import cx from 'classnames';

import './iq-logo-animated.css';

export default function IQLogoAnimated({ isLogoMinimized }: { isLogoMinimized?: boolean }) {
  return (
    <svg
      id="ezX1v374wQ91"
      className={cx({ 'iq-logo-animation-stop': isLogoMinimized })}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 370 370"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="20a857c6aded4f2898ea4ca976c25ef6"
      export-id="b09b27f26898443a874a11e96aff87af"
    >
      <defs>
        <linearGradient
          id="ezX1v374wQ95-fill"
          x1="43.1164"
          y1="181.913"
          x2="354.449"
          y2="184.605"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="ezX1v374wQ95-fill-0" offset="0%" stopColor="#dcb4ff" />
          <stop id="ezX1v374wQ95-fill-1" offset="14%" stopColor="#d6adfc" />
          <stop id="ezX1v374wQ95-fill-2" offset="34%" stopColor="#c59cf4" />
          <stop id="ezX1v374wQ95-fill-3" offset="56%" stopColor="#aa80e6" />
          <stop id="ezX1v374wQ95-fill-4" offset="80%" stopColor="#845ad4" />
          <stop id="ezX1v374wQ95-fill-5" offset="100%" stopColor="#6035c3" />
        </linearGradient>
        <radialGradient
          id="ezX1v374wQ96-fill"
          cx="0"
          cy="0"
          r="1"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(126.811 0 0 128.636 190.014 149.246)"
        >
          <stop id="ezX1v374wQ96-fill-0" offset="0%" stopColor="#6636b5" />
          <stop id="ezX1v374wQ96-fill-1" offset="12%" stopColor="rgba(102,54,181,0.769)" />
          <stop id="ezX1v374wQ96-fill-2" offset="29%" stopColor="rgba(102,54,181,0.502)" />
          <stop id="ezX1v374wQ96-fill-3" offset="45%" stopColor="rgba(102,54,181,0.278)" />
          <stop id="ezX1v374wQ96-fill-4" offset="59%" stopColor="rgba(102,54,181,0.129)" />
          <stop id="ezX1v374wQ96-fill-5" offset="71%" stopColor="rgba(102,54,181,0.031)" />
          <stop id="ezX1v374wQ96-fill-6" offset="81%" stopColor="rgba(102,54,181,0)" />
        </radialGradient>
        <radialGradient
          id="ezX1v374wQ97-fill"
          cx="0"
          cy="0"
          r="1"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(285.567 0 0 285.592 32.629 172.822)"
        >
          <stop id="ezX1v374wQ97-fill-0" offset="11%" stopColor="#c497fd" />
          <stop id="ezX1v374wQ97-fill-1" offset="100%" stopColor="#664cce" />
        </radialGradient>
        <linearGradient
          id="ezX1v374wQ98-fill"
          x1="188.122"
          y1="89.968"
          x2="253.242"
          y2="236.208"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="ezX1v374wQ98-fill-0" offset="0%" stopColor="#9a6aef" />
          <stop id="ezX1v374wQ98-fill-1" offset="100%" stopColor="#6f4fd4" />
        </linearGradient>
        <linearGradient
          id="ezX1v374wQ99-fill"
          x1="40.7545"
          y1="154.876"
          x2="346.853"
          y2="224.224"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="ezX1v374wQ99-fill-0" offset="0%" stopColor="#d7abff" />
          <stop id="ezX1v374wQ99-fill-1" offset="17%" stopColor="#b88df2" />
          <stop id="ezX1v374wQ99-fill-2" offset="30%" stopColor="#9267e1" />
          <stop id="ezX1v374wQ99-fill-3" offset="43.8%" stopColor="#764bd5" />
          <stop id="ezX1v374wQ99-fill-4" offset="85%" stopColor="#653ace" />
          <stop id="ezX1v374wQ99-fill-5" offset="100%" stopColor="#5f35cc" />
        </linearGradient>
        <linearGradient
          id="ezX1v374wQ912-fill"
          x1="5.75377"
          y1="78.19"
          x2="311.852"
          y2="147.537"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="ezX1v374wQ912-fill-0" offset="0%" stopColor="#d7abff" />
          <stop id="ezX1v374wQ912-fill-1" offset="17%" stopColor="#b88df2" />
          <stop id="ezX1v374wQ912-fill-2" offset="30%" stopColor="#9267e1" />
          <stop id="ezX1v374wQ912-fill-3" offset="43.8%" stopColor="#764bd5" />
          <stop id="ezX1v374wQ912-fill-4" offset="85%" stopColor="#653ace" />
          <stop id="ezX1v374wQ912-fill-5" offset="100%" stopColor="#5f35cc" />
        </linearGradient>
        <filter id="ezX1v374wQ914-filter" x="-150%" y="-150%" width="400%" height="400%">
          <feGaussianBlur id="ezX1v374wQ914-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="7.5,7.5" />
          <feOffset id="ezX1v374wQ914-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="ezX1v374wQ914-filter-drop-shadow-0-flood" floodColor="#c69df5" />
          <feComposite id="ezX1v374wQ914-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="ezX1v374wQ914-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="ezX1v374wQ914-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="ezX1v374wQ914-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="ezX1v374wQ922-filter" x="-150%" y="-150%" width="400%" height="400%">
          <feGaussianBlur id="ezX1v374wQ922-filter-drop-shadow-0-blur" in="SourceAlpha" stdDeviation="8,8" />
          <feOffset id="ezX1v374wQ922-filter-drop-shadow-0-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="ezX1v374wQ922-filter-drop-shadow-0-flood" floodColor="#9356da" />
          <feComposite id="ezX1v374wQ922-filter-drop-shadow-0-composite" operator="in" in2="tmp" />
          <feMerge id="ezX1v374wQ922-filter-drop-shadow-0-merge" result="result">
            <feMergeNode id="ezX1v374wQ922-filter-drop-shadow-0-merge-node-1" />
            <feMergeNode id="ezX1v374wQ922-filter-drop-shadow-0-merge-node-2" in="SourceGraphic" />
          </feMerge>
          <feGaussianBlur id="ezX1v374wQ922-filter-drop-shadow-1-blur" in="result" stdDeviation="8,8" />
          <feOffset id="ezX1v374wQ922-filter-drop-shadow-1-offset" dx="0" dy="0" result="tmp" />
          <feFlood id="ezX1v374wQ922-filter-drop-shadow-1-flood" floodColor="#5b0a6e" />
          <feComposite id="ezX1v374wQ922-filter-drop-shadow-1-composite" operator="in" in2="tmp" />
          <feMerge id="ezX1v374wQ922-filter-drop-shadow-1-merge" result="result">
            <feMergeNode id="ezX1v374wQ922-filter-drop-shadow-1-merge-node-1" />
            <feMergeNode id="ezX1v374wQ922-filter-drop-shadow-1-merge-node-2" in="result" />
          </feMerge>
        </filter>
        <radialGradient
          id="ezX1v374wQ922-stroke"
          cx="0"
          cy="0"
          r="2.533065"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="matrix(0.821608 0.570053 -0.570053 0.821608 0.063068 0.180192)"
        >
          <stop id="ezX1v374wQ922-stroke-0" offset="0%" stopColor="#c59cea" />
          <stop id="ezX1v374wQ922-stroke-1" offset="47%" stopColor="#6b41c6" />
        </radialGradient>
      </defs>
      <g mask="url(#ezX1v374wQ920)">
        <g clipPath="url(#ezX1v374wQ917)">
          <g>
            <path
              d="M335.009,183.286c-.044,37.348-14.062,73.327-39.297,100.86s-59.859,44.626-97.061,47.917c-37.203,3.291-74.29-7.459-103.9662-30.134-29.6762-22.676-49.7928-55.635-56.3925-92.395-6.5996-36.76.7955-74.659,20.7306-106.242C78.958,71.7101,109.99,48.7308,146.014,38.8752s74.431-5.8741,107.668,11.1614c33.236,17.0354,58.894,45.8915,71.927,80.8914c6.237,16.751,9.421,34.484,9.4,52.358Z"
              fill="url(#ezX1v374wQ95-fill)"
            />
            <g id="ezX1v374wQ96_to" transform="translate(167.52905,185.669202)">
              <path
                d="M183.919,249.163c54.291,0,98.303-44.645,98.303-99.718c0-55.0727-44.012-99.718-98.303-99.718s-98.3028,44.6453-98.3028,99.718c0,55.073,44.0118,99.718,98.3028,99.718Z"
                transform="translate(-121.040499,-168.254597)"
                fill="url(#ezX1v374wQ96-fill)"
              />
            </g>
            <g id="ezX1v374wQ97_ts" transform="translate(185.019653,233.904472) scale(1,1)">
              <path
                d="M334.829,183.87c-.028,59.7-34.8,113.8-88.8,138.157-26.566,11.859-56.01,15.724-84.736,11.123-28.727-4.601-55.491-17.469-77.024-37.032s-36.902-44.974-44.2299-73.128c-7.3279-28.155-6.2972-57.834,2.966-85.412c6.721,14.324,13.924,28.021,23.537,40.553c21.755,28.492,57.7999,61.155,108.5659,60.668c1.056,0,2.117-.03,3.192-.072c51.163-1.87,11.519-63.57,37.425-93.8c10.715-12.492,99.111,2.963,104.514-5.473c2.2-3.428,2.906-4.532,4.166-6.68c6.235,16.908,10.446,33.051,10.424,51.093v.003Z"
                transform="translate(-185.019653,-233.904472)"
                fill="url(#ezX1v374wQ97-fill)"
              />
            </g>
            <g id="ezX1v374wQ98_ts" transform="translate(220.682198,163.087959) scale(1,1)">
              <path
                id="ezX1v374wQ98"
                d="M188.122,89.968c49.974-22.2531,105.064-7.5563,123.046,32.827c17.983,40.383-7.952,91.16-57.926,113.413s-105.063,7.556-123.046-32.827c-17.982-40.383,7.952-91.16,57.926-113.413Z"
                transform="translate(-220.682198,-163.087959)"
                fill="url(#ezX1v374wQ98-fill)"
              />
            </g>
            <g id="ezX1v374wQ99_tr" transform="translate(269.801085,277.644124) rotate(0)">
              <g id="ezX1v374wQ99_ts" transform="scale(1,1)">
                <path
                  id="ezX1v374wQ99"
                  d="M76.3991,289.984c-38.053-40.085-51.591-100.083-33.393-152.249c7.212,14.212,14.531,28.8,24.141,41.33.878,22.588,10.464,110.281,113.3229,120.947c29.493,3.088,59.016-5.55,82.193-24.048c19.218-15.408,32.325-34.481,38.466-62.2s-19.418-66.3-50.95-63.975-36.862,14.978-47.2,25.025c-39.236,35.345-50.85,33.637-62.578,29.392-.49-.121-.977-.254-1.461-.4-1.661-.671-3.214-1.58-4.612-2.7-3.567-2.937-6.211-6.841-7.614-11.244-1.828-5.111-2.749-10.501-2.722-15.929.031-1.509.109-3.015.233-4.517.062-1.195.157-2.389.286-3.582.666-4.68,1.763-9.287,3.276-13.765.226-.675.462-1.348.707-2.017c3.035-8.171,7.216-15.868,12.416-22.863c1.284-1.753,2.626-3.462,4.027-5.129c1.6-1.916,3.278-3.788,5.035-5.615c5.873-6.147,12.389-11.645,19.436-16.4c16.724-11.3158,35.844-18.5987,55.858-21.2761c6.778-.9,13.366-1.555,19.733-1.821c24.9-1.411,43.032,2.653,57.2,18c1.237,1.2187,2.446,2.5111,3.625,3.8771c3.924,3.4,14.9,13.485,22.84,41.156c8.8,30.641,5.033,69.409,2.393,81.121l-.081.308c-15.4,58.3-64.076,108.409-146.283,115.044h-.076c-20.247-.002-40.282-4.122-58.886-12.111s-35.3881-19.679-49.3319-34.359Zm254.6639-68.89c15.268-57.783-.071.308-.071.308.024-.1.047-.203.071-.308Z"
                  transform="translate(-269.801079,-277.64412)"
                  fill="url(#ezX1v374wQ99-fill)"
                />
              </g>
            </g>
            <g id="ezX1v374wQ912_tr" transform="translate(-82.079276,215.783113) rotate(-47.049489)">
              <g id="ezX1v374wQ912_ts" transform="scale(-0.828026,1)">
                <path
                  id="ezX1v374wQ912"
                  d="M266.128,137.077c6.141-27.719-19.418-66.2995-50.95-63.9745s-36.862,14.9779-47.2,25.0249c-39.236,35.3446-50.85,33.6366-62.578,29.3916-.49-.12-.977-.254-1.461-.4-1.66-.67-3.214-1.58-4.6116-2.699-3.5676-2.937-6.2114-6.842-7.614-11.245-1.8282-5.11-2.7495-10.501-2.722-15.9286.0313-1.5093.109-3.015.233-4.517.062-1.1953.1573-2.3893.286-3.582.666-4.6794,1.7627-9.2873,3.276-13.765.226-.6753.4616-1.3476.707-2.017c3.0353-8.1704,7.2156-15.8683,12.4156-22.863c1.284-1.7527,2.627-3.4622,4.027-5.1289c1.6-1.916,3.279-3.7877,5.035-5.615c5.873-6.147,12.389-11.6452,19.436-16.4c16.724-11.3158,35.844-18.59861,55.858-21.27603c6.778-.9,13.366-1.555045,19.733-1.821045c24.9-1.410995,43.032,2.652995,57.2,17.999975c1.238,1.2187,2.446,2.5111,3.625,3.8771c3.924,3.4,14.9,13.485,22.84,41.156c8.8,30.641,5.033,69.4085,2.393,81.1205l-.081.308q-26.8623-6.8814-29.847-7.646Z"
                  transform="translate(-376.007297,-98.815157)"
                  opacity="0"
                  fill="url(#ezX1v374wQ912-fill)"
                />
              </g>
            </g>
            <path
              d="M370,370h-370L0,0h370v370ZM251.139,55.9629C218.911,39.4442,181.668,35.583,146.736,45.1396c-34.931,9.5568-65.0218,31.8395-84.3522,62.4644-19.3303,30.624-26.5009,67.373-20.1016,103.018c6.3995,35.645,25.9056,67.606,54.6817,89.594s64.7391,32.411,100.8131,29.22c36.074-3.192,69.648-19.767,94.118-46.464c24.469-26.698,38.062-61.586,38.105-97.801.02-17.332-3.067-34.527-9.115-50.77-12.638-33.938-37.518-61.9193-69.746-78.4381Z"
              fill="#fff"
            />
            <g filter="url(#ezX1v374wQ914-filter)">
              <circle r="144.5" transform="translate(185 185)" fill="none" stroke="#9874df" strokeOpacity="0.01" />
            </g>
          </g>
          <clipPath id="ezX1v374wQ917">
            <rect width="370" height="370" rx="0" ry="0" fill="#fff" />
          </clipPath>
        </g>
        <path
          d="M-2.107337,-4.071465h377.215887v378.675935h-377.215887v-378.675935Z"
          transform="matrix(.98878 0 0 1 2.083835 0)"
          fill="none"
          stroke="#fff"
          strokeWidth="15"
        />
        <mask id="ezX1v374wQ920" mask-type="alpha" x="-150%" y="-150%" height="400%" width="400%">
          <ellipse
            rx="150.422419"
            ry="145.396874"
            transform="matrix(.9706 0 0 1.007587 184.499999 185.60972)"
            fill="#d2dbed"
            strokeWidth="0"
          />
        </mask>
      </g>
      {!isLogoMinimized && (
        <ellipse
          id="ezX1v374wQ922"
          rx="98.135493"
          ry="102.969133"
          transform="matrix(1.477549 0 0 1.408189 184.506431 185.669202)"
          filter="url(#ezX1v374wQ922-filter)"
          fill="rgba(255,255,255,0.02)"
          stroke="url(#ezX1v374wQ922-stroke)"
          strokeWidth="2"
        />
      )}
    </svg>
  );
}
